import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { Dealer } from './state/types';
import * as S from './styles';
import { getChatmeterSSOToken, getChatmeterSSOTokenSuccess, getChatmeterSSOTokenError, setShowHeader } from './state/actions';
import { getCharmeterSSOToken, getCharmeterSSOTokenError } from './state/selector';
import { Loader } from '../../../components/Loader'
import InformationScreen from "../InformationScreen"
import { getEnginePerPackage } from 'common/utils';
import { ListingType } from 'features/Dealers/Listings/state/types';
export interface RootProps {
    dealers: Dealer[];
}

const AdvancedLm = (props: any) => {
    const [error, setError] = React.useState<string|undefined> (undefined);
    const ssoToken = useSelector(getCharmeterSSOToken);
    const ssoTokenError = useSelector(getCharmeterSSOTokenError);
    const dispatch = useDispatch();
    const [token, setToken] = React.useState<string|undefined>(undefined);
    const [isSynced, setIsSynced] = React.useState(false);

    const { user, selectedDealer, listingsByDealerId } = useSelector((rootState: RootState) => {
        return {
            user:rootState.security.user,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            listingsByDealerId: rootState.dealers.listing.listings.byDealerId,
        }
    }, shallowEqual);

    React.useEffect(() => {  
        if (user?.email && isSynced) {
            dispatch(setShowHeader(false));
            dispatch(getChatmeterSSOToken(user?.email));
        }
    },[isSynced])

    React.useEffect(() => {    
        if (ssoTokenError) {
            setError("authenticationError");
            dispatch(getChatmeterSSOTokenError(undefined));
            dispatch(setShowHeader(true)); 
        }
    },[ssoTokenError])

    React.useEffect(() => {    
        if (ssoToken && ssoToken!="") {
            setToken(ssoToken);
            dispatch(getChatmeterSSOTokenSuccess("")); 
        }
    },[ssoToken])

    React.useEffect(() => {
        if (selectedDealer && listingsByDealerId)
        {
            if (listingsByDealerId[selectedDealer.id]) 
            {
                const engine = getEnginePerPackage(selectedDealer?.lmPackage);
                const primaryListing = listingsByDealerId[selectedDealer.id].find(listing => listing.type == ListingType.PRIMARY && listing.engineId==engine);
                if (primaryListing){
                    setIsSynced(primaryListing.statusSync==="SYNCED");
                    if (primaryListing?.statusSync!=="SYNCED")  {
                        setError("notSyncError");
                        dispatch(setShowHeader(true));
                    } else dispatch(setShowHeader(false));
                } else setError("notSyncError");         
            }
        }                 
    }, [selectedDealer, listingsByDealerId]);

    return (
        <S.MainContainer>
            {error 
            ? <InformationScreen id={error}/>
            : !token
                ? <Loader/>
                : <S.IFrame 
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads" 
                    src={`https://listingsmanagerpro.dealeron.com/#/login?ssoToken=${token}&iFrame=true`}/>
            }
        </S.MainContainer>
    )
}

export default AdvancedLm;
